import { QrModule } from "../../models/Publish/qr";
import { SEND_QR_MAIL } from "../constants/qr";

export const sendQrMail = (payload: QrModule.QrMail) => {
  return {
    type: SEND_QR_MAIL,
    payload,
  };
};
